import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

import Button from '../../../components/ui/Button';

import { trackSearch, trackButtonClick } from '../../../utils/googleAnalyticsService';

const SearchFilters = ({
  onSearch,
  onFilter,
  onClearFilters,
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  sortBy,
  setSortBy
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const handleStatusChange = (status) => {
    setStatusFilter(status);
    onFilter({ status, date: '' });
  };

  const handleClearAll = () => {
    setSearchTerm('');
    setStatusFilter('');
    setSortBy('date-desc');
    onClearFilters();
  };

  const handleSearch = (searchTerm) => {
    // Track search action
    trackSearch(searchTerm, 0, {
      source: 'dashboard',
      filter_type: 'trip_search',
    });

    onSearch(searchTerm);
  };

  const handleFilterApply = (filters) => {
    // Track filter application
    trackButtonClick('apply_filters', 'Apply Filters', {
      filter_count: Object.keys(filters)?.length,
      filters: JSON.stringify(filters),
    });

    onFilter(filters);
  };

  return (
    <div className="bg-card border border-border rounded-organic p-4 shadow-organic">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Search Input */}
        <div className="flex-1">
          <div className="relative">
            <Icon 
              name="Search" 
              size={16} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
            <input
              type="text"
              placeholder="Search trips by destination or park..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e?.target?.value);
                handleSearch(e?.target?.value);
              }}
              className="w-full pl-10 pr-4 py-2 border border-input bg-background rounded-organic focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </div>

        {/* Filter Toggle Button */}
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`px-4 py-2 rounded-organic border transition-colors flex items-center space-x-2 ${
            showFilters || statusFilter 
              ? 'bg-primary text-primary-foreground border-primary' 
              : 'bg-background text-foreground border-input hover:bg-muted'
          }`}
        >
          <Icon name="Filter" size={16} />
          <span>Filter</span>
          {statusFilter && (
            <span className="bg-primary-foreground text-primary rounded-full w-5 h-5 flex items-center justify-center text-xs">
              1
            </span>
          )}
        </button>

        {/* Sort Dropdown */}
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e?.target?.value)}
          className="px-4 py-2 border border-input bg-background rounded-organic focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="date-desc">Trip Date (Newest First)</option>
          <option value="date-asc">Trip Date (Oldest First)</option>
          <option value="created-desc">Created Date (Newest First)</option>
          <option value="created-asc">Created Date (Oldest First)</option>
          <option value="name-asc">Name (A-Z)</option>
          <option value="name-desc">Name (Z-A)</option>
          <option value="status">Status</option>
        </select>
      </div>
      {/* Expanded Filters */}
      {showFilters && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="space-y-3">
            <div>
              <label className="font-body-medium text-sm text-card-foreground mb-2 block">
                Trip Status
              </label>
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => handleStatusChange('')}
                  className={`px-3 py-1 rounded-organic text-sm transition-colors ${
                    statusFilter === '' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                >
                  All
                </button>
                <button
                  onClick={() => handleStatusChange('upcoming')}
                  className={`px-3 py-1 rounded-organic text-sm transition-colors ${
                    statusFilter === 'upcoming' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                >
                  Upcoming
                </button>
                <button
                  onClick={() => handleStatusChange('planning')}
                  className={`px-3 py-1 rounded-organic text-sm transition-colors ${
                    statusFilter === 'planning' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                >
                  Planning
                </button>
                <button
                  onClick={() => handleStatusChange('completed')}
                  className={`px-3 py-1 rounded-organic text-sm transition-colors ${
                    statusFilter === 'completed' ? 'bg-success text-white' : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                >
                  Completed
                </button>
              </div>
            </div>

            {(searchTerm || statusFilter) && (
              <button
                onClick={handleClearAll}
                className="text-sm text-muted-foreground hover:text-foreground flex items-center space-x-1"
              >
                <Icon name="X" size={14} />
                <span>Clear all filters</span>
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchFilters;